import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import SelectedWork from "@/components/SelectedWork";
import HowIWork from "@/components/HowIWork";
import About from "@/components/About";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function Portfolio() {
  return (
    <div
      className="min-h-screen bg-[#FFFFFF] text-[#0A0A0A]"
      data-testid="portfolio-root"
    >
      <Nav />
      <main>
        <Hero />
        <SelectedWork />
        <HowIWork />
        <About />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
